export const isFullNameInvalid = (name: string | undefined): boolean =>
    !name || name.trim().split(/\s+/).filter(Boolean).length < 2;
